import { Stack as ReactStack } from "@certn/cascadia-react/foundations/grid-layout/Stack";
import { memo } from "react";

import { CascadiaStackProps } from "./types";

export const Stack = memo(function (props: CascadiaStackProps) {
  return <ReactStack {...props} />;
});
